export default __webpack_public_path__ + "static/media/Bloodseraph's Legguards.e1436681.jpg";